import { colors, greys } from "@styles/color.styles";
import { CSSProperties } from "@material-ui/core/styles/withStyles";

export const container: CSSProperties = {
  display: "flex",
  alignItems: "center",
  textAlign: "center",
  flexDirection: "column",
};

export const button: CSSProperties = {
  backgroundColor: colors.blueDusk.standard,
  color: greys.white,
  "&:hover": {
    backgroundColor: colors.blueDusk.darker,
  },
};

export const styles = {
  button,
  container,
};
